export enum AsyncStatus {
  Unknown,
  Failed,
  Pending,
  Success
}